import React, { useState } from 'react';
import i18n from 'i18next';

import { useLanguage } from '../../contexts/LanguageContext';
import { useResto } from '../../contexts/RestoContext';
import config from '../../config/config';

const LanguageSelector = () => {
  const { activeLanguage, updateLanguage } = useLanguage();
  const { restoData } = useResto();
  const [showFlags, setShowFlags] = useState(false);

  if (!restoData || !restoData.availableLanguages || restoData.availableLanguages.length <= 1) {
    return null;
  }
  
  const handleLanguageChange = (lang) => {
    updateLanguage(lang);
    i18n.changeLanguage(lang);
    setShowFlags(false);
  };

  const toggleFlags = () => {
    setShowFlags(!showFlags);
  };

  const renderFlags = () => {
    if (restoData && restoData.availableLanguages && showFlags) {
      return (
        <div className="flag-container vertical background-main-color-80" style={{ color: 'rgb(255,255,255)', padding: '0px 0px 5px'}}>
          {restoData.availableLanguages.map((lang) => (
            (lang !== activeLanguage) && (
              <span key={lang} onClick={() => handleLanguageChange(lang)} className="flag_icon">
                <img src={`${config.kubuniImagesUrl}general-icons/flag_${lang}_icon_24.png`} alt={lang} />
              </span>
            )
          ))}
        </div>
      );
    }
  };

  return (
    <div className={`language-selector mr-3 ${showFlags ? 'expanded' : ''}`}>
      <span onClick={toggleFlags} className={`flag_icon ${showFlags ? 'flag_icon_active' : ''}`}>
        <img src={`${config.kubuniImagesUrl}general-icons/flag_${activeLanguage}_icon_24.png`} alt={activeLanguage} />
      </span>
      {renderFlags()}
    </div>
  );
}

export default LanguageSelector;
